import styled from "@emotion/styled";

import { APPLE_BLUE, APPLE_GREY, APPLE_WHITE } from "../../constants";

import { Card, CardStyle, MOBILE_CARD_WIDTH } from "./Card";
import { IconButton } from "../Buttons/IconButton";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface CardSocialProps {
  isGrabbing: boolean;
}

export const CardSocialLinkedIn = ({ isGrabbing }: CardSocialProps) => {
  return (
    <Card
      cardStyle={CardStyle.SQUARE_1}
      xsHeight={MOBILE_CARD_WIDTH}
      backgroundColor={APPLE_BLUE}
      isGrabbing={isGrabbing}
    >
      <Container>
        <svg
          width={50}
          height={50}
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="rgb(255, 255, 255)"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
          }}
        >
          <path
            d="M5.54736 21H1.19267V6.97969H5.54736V21ZM3.36767 5.06719C1.97548 5.06719 0.845795 3.91406 0.845795 2.52187C0.845795 1.12969 1.97548 0 3.36767 0C4.75986 0 5.88954 1.12969 5.88954 2.52187C5.88954 3.91406 4.75986 5.06719 3.36767 5.06719ZM21.8458 21H17.5005V14.175C17.5005 12.5484 17.4677 10.4625 15.2364 10.4625C12.9724 10.4625 12.6255 12.2297 12.6255 14.0578V21H8.27548V6.97969H12.452V8.89219H12.513C13.0942 7.79062 14.5145 6.62812 16.6333 6.62812C21.0395 6.62812 21.8505 9.52969 21.8505 13.2984V21H21.8458Z"
            fill="currentColor"
          />
        </svg>
      </Container>
      <Container>
        <IconButton
          style={{
            position: "absolute",
            bottom: 16,
            left: 16,
          }}
          onClick={() =>
            window.open("https://www.linkedin.com/in/alex-badia", "_blank")
          }
        />
      </Container>
    </Card>
  );
};

export const CardSocialGitHub = ({ isGrabbing }: CardSocialProps) => {
  return (
    <Card
      cardStyle={CardStyle.SQUARE_1}
      xsHeight={MOBILE_CARD_WIDTH}
      backgroundColor={APPLE_GREY}
      isGrabbing={isGrabbing}
    >
      <Container>
        <svg
          viewBox="0 0 25 25"
          width={50}
          height={50}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="rgb(255, 255, 255)"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
          }}
        >
          <path
            d="M8.62706 18.6281C8.62706 18.7219 8.51924 18.7969 8.38331 18.7969C8.22862 18.8109 8.12081 18.7359 8.12081 18.6281C8.12081 18.5344 8.22862 18.4594 8.36456 18.4594C8.50518 18.4453 8.62706 18.5203 8.62706 18.6281ZM7.16924 18.4172C7.13643 18.5109 7.23018 18.6187 7.37081 18.6469C7.49268 18.6937 7.63331 18.6469 7.66143 18.5531C7.68956 18.4594 7.60049 18.3516 7.45987 18.3094C7.33799 18.2766 7.20206 18.3234 7.16924 18.4172ZM9.24112 18.3375C9.10518 18.3703 9.01143 18.4594 9.02549 18.5672C9.03956 18.6609 9.16143 18.7219 9.30206 18.6891C9.43799 18.6562 9.53174 18.5672 9.51768 18.4734C9.50362 18.3844 9.37706 18.3234 9.24112 18.3375ZM12.3255 0.375C5.82393 0.375 0.850494 5.31094 0.850494 11.8125C0.850494 17.0109 4.12237 21.4594 8.79581 23.025C9.39581 23.1328 9.60674 22.7625 9.60674 22.4578C9.60674 22.1672 9.59268 20.5641 9.59268 19.5797C9.59268 19.5797 6.31143 20.2828 5.62237 18.1828C5.62237 18.1828 5.08799 16.8187 4.31924 16.4672C4.31924 16.4672 3.24581 15.7312 4.39424 15.7453C4.39424 15.7453 5.56143 15.8391 6.20362 16.9547C7.23018 18.7641 8.95049 18.2437 9.62081 17.9344C9.72862 17.1844 10.0333 16.6641 10.3708 16.3547C7.75049 16.0641 5.10674 15.6844 5.10674 11.175C5.10674 9.88594 5.46299 9.23906 6.21299 8.41406C6.09112 8.10938 5.69268 6.85312 6.33487 5.23125C7.31456 4.92656 9.56924 6.49688 9.56924 6.49688C10.5067 6.23438 11.5146 6.09844 12.513 6.09844C13.5114 6.09844 14.5192 6.23438 15.4567 6.49688C15.4567 6.49688 17.7114 4.92188 18.6911 5.23125C19.3333 6.85781 18.9349 8.10938 18.813 8.41406C19.563 9.24375 20.0224 9.89062 20.0224 11.175C20.0224 15.6984 17.2614 16.0594 14.6411 16.3547C15.0724 16.725 15.438 17.4281 15.438 18.5297C15.438 20.1094 15.4239 22.0641 15.4239 22.4484C15.4239 22.7531 15.6396 23.1234 16.2349 23.0156C20.9224 21.4594 24.1005 17.0109 24.1005 11.8125C24.1005 5.31094 18.8271 0.375 12.3255 0.375ZM5.40674 16.5422C5.34581 16.5891 5.35987 16.6969 5.43956 16.7859C5.51456 16.8609 5.62237 16.8938 5.68331 16.8328C5.74424 16.7859 5.73018 16.6781 5.65049 16.5891C5.57549 16.5141 5.46768 16.4812 5.40674 16.5422ZM4.90049 16.1625C4.86768 16.2234 4.91456 16.2984 5.00831 16.3453C5.08331 16.3922 5.17706 16.3781 5.20987 16.3125C5.24268 16.2516 5.19581 16.1766 5.10206 16.1297C5.00831 16.1016 4.93331 16.1156 4.90049 16.1625ZM6.41924 17.8312C6.34424 17.8922 6.37237 18.0328 6.48018 18.1219C6.58799 18.2297 6.72393 18.2437 6.78487 18.1688C6.84581 18.1078 6.81768 17.9672 6.72393 17.8781C6.62081 17.7703 6.48018 17.7563 6.41924 17.8312ZM5.88487 17.1422C5.80987 17.1891 5.80987 17.3109 5.88487 17.4188C5.95987 17.5266 6.08643 17.5734 6.14737 17.5266C6.22237 17.4656 6.22237 17.3438 6.14737 17.2359C6.08174 17.1281 5.95987 17.0813 5.88487 17.1422Z"
            fill="currentColor"
          ></path>
        </svg>
      </Container>
      <Container>
        <IconButton
          style={{
            position: "absolute",
            bottom: 16,
            left: 16,
          }}
          onClick={() => window.open("https://github.com/alexbadia1", "_blank")}
        />
      </Container>
    </Card>
  );
};

export const CardSocialMedium = ({ isGrabbing }: CardSocialProps) => {
  return (
    <Card
      cardStyle={CardStyle.SQUARE_1}
      xsHeight={MOBILE_CARD_WIDTH}
      backgroundColor={APPLE_WHITE}
      isGrabbing={isGrabbing}
    >
      <Container>
        <svg
          width="140"
          height="140"
          viewBox="0 0 3940 610"
          fill="black"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
          }}
        >
          <path d="M594.79,308.2c0,163.76-131.85,296.52-294.5,296.52S5.8,472,5.8,308.2,137.65,11.69,300.29,11.69s294.5,132.75,294.5,296.51" />
          <path d="M917.86,308.2c0,154.16-65.93,279.12-147.25,279.12s-147.25-125-147.25-279.12S689.29,29.08,770.61,29.08s147.25,125,147.25,279.12" />
          <path d="M1050,308.2c0,138.12-23.19,250.08-51.79,250.08s-51.79-112-51.79-250.08S969.61,58.12,998.22,58.12,1050,170.09,1050,308.2" />
          <path d="M1862.77,37.4l.82-.18V30.87H1696.11L1540.6,396.37,1385.09,30.87H1204.61v6.35l.81.18c30.57,6.9,46.09,17.19,46.09,54.3V526.15c0,37.11-15.58,47.4-46.15,54.3l-.81.18V587H1327v-6.35l-.81-.18c-30.57-6.9-46.09-17.19-46.09-54.3V116.9L1479.87,587h11.33l205.59-483.21V536.9c-2.62,29.31-18,38.36-45.68,44.61l-.82.19V588h213.3V581.7l-.82-.19c-27.71-6.25-43.46-15.3-46.08-44.61l-.14-445.2h.14c0-37.11,15.52-47.4,46.08-54.3m97.43,287.8c3.49-78.06,31.52-134.4,78.56-135.37,14.51.24,26.68,5,36.14,14.16,20.1,19.51,29.55,60.28,28.09,121.21Zm-2.11,22h250v-1.05c-.71-59.69-18-106.12-51.34-138-28.82-27.55-71.49-42.71-116.31-42.71h-1c-23.26,0-51.79,5.64-72.09,15.86C1944.24,192,1923.86,208,1906.9,229c-27.3,33.83-43.84,79.55-47.86,130.93-.13,1.54-.24,3.08-.35,4.62s-.18,2.92-.25,4.39c-.14,2.75-.25,5.51-.31,8.28-.1,4.44-.13,8.91-.05,13.41C1860.79,507,1923.65,600,2035.3,600c98,0,155.07-71.64,169.3-167.8l-7.19-2.53c-25,51.68-69.9,83-121,79.18-69.76-5.22-123.2-75.95-118.35-161.63M2490.75,504.9c-8.2,19.45-25.31,30.15-48.24,30.15s-43.89-15.74-58.78-44.34c-16-30.7-24.42-74.1-24.42-125.51,0-107,33.28-176.21,84.79-176.21,21.57,0,38.55,10.7,46.65,29.37Zm165.84,76.28c-30.57-7.23-46.09-18-46.09-57V5.28L2424.77,60v6.7l1.14-.09c25.62-2.07,43,1.47,53.09,10.79,7.9,7.3,11.75,18.5,11.75,34.26V182.8c-18.31-11.69-40.09-17.38-66.52-17.38-53.6,0-102.59,22.57-137.92,63.56-36.83,42.72-56.3,101.1-56.3,168.81C2230,518.72,2289.53,600,2378.13,600c51.83,0,93.53-28.4,112.62-76.3V588H2657.4v-6.66ZM2815.88,75.85c0-37.76-28.47-66.24-66.24-66.24-37.59,0-67,29.1-67,66.24s29.44,66.24,67,66.24c37.77,0,66.24-28.48,66.24-66.24m43.84,505.33c-30.57-7.23-46.09-18-46.09-57h-.13V166.65L2646.84,214.5V221l1,.09c36.06,3.21,45.93,15.63,45.93,57.77V588h166.8v-6.66Zm427.05,0c-30.57-7.23-46.09-18-46.09-57V166.65L3082,212.92v6.52l.94.1c29.48,3.1,38,16.23,38,58.56v226c-9.83,19.45-28.27,31-50.61,31.78-36.23,0-56.18-24.47-56.18-68.9V166.66l-166.66,47.85V221l1,.09c36.06,3.2,45.94,15.62,45.94,57.77V470.13a214.48,214.48,0,0,0,3.47,39.82l3,13.05c14.11,50.56,51.08,77,109,77,49.06,0,92.06-30.37,111-77.89v66h166.66v-6.66ZM3934.2,588v-6.67l-.81-.19c-33.17-7.65-46.09-22.07-46.09-51.43V286.51c0-75.83-42.59-121.09-113.93-121.09-52,0-95.85,30.05-112.73,76.86-13.41-49.6-52-76.86-109.06-76.86-50.12,0-89.4,26.45-106.25,71.13V166.68l-166.66,45.89v6.54l1,.09c35.63,3.16,45.93,15.94,45.93,57V588H3481.1v-6.66l-.82-.2c-26.46-6.22-35-17.56-35-46.66V255.72c7-16.35,21.11-35.72,49-35.72,34.64,0,52.2,24,52.2,71.28V588h155.54v-6.66l-.82-.2c-26.46-6.22-35-17.56-35-46.66v-248A160.45,160.45,0,0,0,3664,258.8c7.42-17.77,22.34-38.8,51.37-38.8,35.13,0,52.2,23.31,52.2,71.28V588Z" />
        </svg>
      </Container>
      <Container>
        <IconButton
          style={{
            position: "absolute",
            bottom: 16,
            left: 16,
          }}
          onClick={() => window.open("https://alexbadia.medium.com/", "_blank")}
        />
      </Container>
    </Card>
  );
};

export const CardSocialDevpost = ({ isGrabbing }: CardSocialProps) => {
  return (
    <Card
      cardStyle={CardStyle.SQUARE_1}
      xsHeight={MOBILE_CARD_WIDTH}
      backgroundColor={APPLE_WHITE}
      isGrabbing={isGrabbing}
    >
      <Container>
        <svg
          width="140"
          height="140"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 600 116.5"
          enableBackground="new 0 0 600 116.5"
          xmlSpace="preserve"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
          }}
        >
          <polygon
            fill="#3ACCE6"
            points="566.4,0 539.8,0 573.4,58.2 539.8,116.5 566.4,116.5 600,58.2 "
          />
          <polygon
            fill="#3ACCE6"
            points="33.6,0 60.2,0 26.6,58.2 60.2,116.5 33.6,116.5 0,58.2 "
          />
          <polygon
            fill="#003E54"
            points="50.2,116.5 16.6,58.2 50.2,0 549.8,0 583.4,58.2 549.8,116.5 "
          />
          <g>
            <path
              fill="#FFFFFF"
              d="M84.2,93.6H63V22.9h22.1c20.2,0,35.2,9.5,35.2,35.4C120.3,83.1,102.3,93.6,84.2,93.6z M84.7,36.6h-7.5v43.2   h7c14.8,0,21.6-8.7,21.6-21.6C105.8,43.8,99.6,36.6,84.7,36.6z"
            />
            <path
              fill="#FFFFFF"
              d="M136.5,93.6V22.9h49.1v13.8h-35v12.2h20.3v13.7h-20.3v17.1h36.5v13.8H136.5z"
            />
            <path
              fill="#FFFFFF"
              d="M237,93.6h-13.7l-25.1-70.7h15.7l13.3,40.9c1.3,3.9,2.7,9.1,3.3,11.6c0.6-2.6,1.9-7.5,3.2-11.6l13-40.9   h15.5L237,93.6z"
            />
            <path
              fill="#FFFFFF"
              d="M306.9,68.5h-15.6v25.1h-14.1V22.9h30.9c13.3,0,24.3,7.4,24.3,22.4C332.5,61.7,321.6,68.5,306.9,68.5z    M307.7,36.6h-16.3v18.2h16.5c6.6,0,10.1-3,10.1-9.2C318,39.4,313.9,36.6,307.7,36.6z"
            />
            <path
              fill="#FFFFFF"
              d="M374.9,94.7c-19.3,0-30.7-15-30.7-36.5s11.4-36.5,30.7-36.5c19.3,0,30.7,15,30.7,36.5   S394.2,94.7,374.9,94.7z M374.9,35.8c-11.4,0-16.2,9.8-16.2,22.4s4.7,22.4,16.2,22.4c11.4,0,16.2-9.8,16.2-22.4   S386.3,35.8,374.9,35.8z"
            />
            <path
              fill="#FFFFFF"
              d="M444.6,94.7c-11.8,0-22.1-4.9-27.5-12.8l10.2-9.1c5,5.8,11.3,8.1,18.1,8.1c8.4,0,12.3-2.3,12.3-7.7   c0-4.5-2.4-6.6-15.8-9.6c-13-3-22.1-7.2-22.1-21.1c0-12.8,11.3-20.7,25.3-20.7c11,0,19.1,4.1,25.8,11.1l-10.2,9.9   c-4.5-4.6-9.6-7.3-16.1-7.3c-7.6,0-10.1,3.2-10.1,6.4c0,4.4,3,5.9,14.2,8.5c11.2,2.6,23.6,6.5,23.6,21.8   C472.4,85.6,463.9,94.7,444.6,94.7z"
            />
            <path
              fill="#FFFFFF"
              d="M516.6,36.8v56.8h-14.1V36.8h-20.3V22.9h54.8v13.9H516.6z"
            />
          </g>
        </svg>
      </Container>
      <Container>
        <IconButton
          style={{
            position: "absolute",
            bottom: 16,
            left: 16,
          }}
          onClick={() =>
            window.open("https://devpost.com/alexbadia1", "_blank")
          }
        />
      </Container>
    </Card>
  );
};
